import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import { IAjaxMapRoundaboutResponse } from 'shared/common/repository-manually-added/monolith-python/ajax/map/roundabout';
import { transformSimilarObjectsToInfrastructureItems } from 'shared/mf-infrastructure/mappers/transformGetAjaxMapRoundaboutResponse/transformSimilarObjectsToInfrastructureItems';
import { similarObjectsItemToGeoObject } from 'shared/mf-infrastructure/utils/infrastructureItems';

export function transformSimilarObjectsToGeoObjects(result: IAjaxMapRoundaboutResponse): IGeoObject[] {
  return transformSimilarObjectsToInfrastructureItems(result).map(similarObjectsItemToGeoObject);
}
